import {format} from 'date-fns';
import { nospace, titlecase } from './string';
import { formatMonth } from './dates';

export const formatCSVfilename = (storeName, reportName, filtered=false, withCsvExtension=false) => {
    const now = new Date();
    const today = format(now, 'ddMMMyy');
    return `${nospace(storeName)}_${nospace(titlecase(reportName))}_${filtered ? 'filtered_' : ''}${today}${withCsvExtension ? ".csv" : ""}`;
}

const formatDateForFilename = (date) => format(new Date(date), 'ddMMMyy').toLowerCase();

const formatMonthForFilename = (date) => formatMonth(date).toLowerCase().replace(' ', '_');

const sanitizeName = (name) => name?.toLowerCase().replace(/\s+/g, '_') || '';

export const csvFilename = (reportName, { date, startDate, endDate, businessName } = {}) => {
    const parts = [];
    if (businessName) parts.push(sanitizeName(businessName));
    parts.push(reportName);

    if (startDate && endDate) {
        parts.push(`${formatMonthForFilename(startDate)}_to_${formatMonthForFilename(endDate)}`);
    } else {
        parts.push(formatDateForFilename(date || new Date()));
    }

    return `${parts.join('_')}.csv`;
};

// Extract text from a column name (handles both strings and React elements)
const getColumnNameText = (name) => {
    if (typeof name === 'string') return name;
    // Handle React elements - try to extract children text
    if (name?.props?.children) {
        const children = name.props.children;
        if (typeof children === 'string') return children;
        if (Array.isArray(children)) {
            return children.filter(c => typeof c === 'string').join('');
        }
    }
    return '';
};

export const getCSVConfig = (columns) => ({
    columns: columns.map(
        column => ({
            name: getColumnNameText(column.name),
            selector: column.selector,
            ...(column?.type === "currency" ? {type: "currency"} : {})
        })
    ).filter(col => col.name) // Filter out columns with empty names
});